import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';
import { Button } from './ui/Button';
import { AgencyModal } from './AgencyModal';
export const CTA = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  return <section className="py-24 bg-white" data-id="element-344" data-mp="1uhpxatqu22x3">
      <AgencyModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} data-id="element-345" data-mp="1uirab3reszhg" />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-346" data-mp="16rluuppds97o">
        <div className="bg-zano-charcoal rounded-3xl p-10 md:p-16 text-center text-white relative overflow-hidden" data-id="element-347" data-mp="16psl31jh18vg">
          <div className="absolute top-0 right-0 w-64 h-64 bg-white/5 rounded-full blur-3xl -translate-y-1/2 translate-x-1/2" data-id="element-348" data-mp="1ghokqh17h71s"></div>
          <div className="absolute bottom-0 left-0 w-64 h-64 bg-zano-pink/20 rounded-full blur-3xl translate-y-1/2 -translate-x-1/2" data-id="element-349" data-mp="1bq6vgq8jouwn"></div>

          <div className="relative z-10 max-w-3xl mx-auto" data-id="element-350" data-mp="nzkluuiw72kj">
            <h2 className="text-3xl md:text-5xl font-bold mb-6" data-id="element-351" data-mp="j1j7gmwevrfe">
              Access the elite layer of talent representation
            </h2>
            <p className="text-lg text-gray-300 mb-10" data-id="element-352" data-mp="33ck9tci631m2">
              Brand, marketing agency, or talent team — join the discovery layer
              for represented influencers.
            </p>

            <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-16" data-id="element-353" data-mp="3d6asu1viyjud">
              <Button variant="secondary" className="bg-transparent text-white border-gray-600 hover:bg-gray-800 hover:border-gray-500 w-full sm:w-auto px-8 py-3" onClick={() => setIsModalOpen(true)} data-id="element-354" data-mp="3h7w119x469y8">
                List Your Agency
              </Button>
              <Link to="/pricing" data-id="element-355" data-mp="2yfa930pbv3ix">
                <Button variant="primary" className="bg-white text-zano-charcoal hover:bg-gray-100 w-full sm:w-auto px-8 py-3" data-id="element-356" data-mp="2ygczz8mnh5yu">
                  Start Free Trial
                </Button>
              </Link>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 text-left" data-id="element-357" data-mp="29roazzymrdj2">
              <div className="bg-gray-800/50 backdrop-blur-sm p-6 rounded-xl border border-gray-700" data-id="element-358" data-mp="25qma7ep2etez">
                <h3 className="font-semibold text-white mb-2" data-id="element-359" data-mp="2jqdn1c3ui3re">Brands</h3>
                <p className="text-sm text-gray-400 mb-4" data-id="element-360" data-mp="2joavgnn1o2kk">
                  Source represented talent and connect with managers directly.
                </p>
                <a href="#" className="text-sm font-medium text-white hover:text-gray-300 flex items-center gap-1" data-id="element-361" data-mp="1r2ria0ivst2y">
                  Learn more <ChevronRight size={16} data-id="element-362" data-mp="20s1b5iljufs4" />
                </a>
              </div>
              <div className="bg-gray-800/50 backdrop-blur-sm p-6 rounded-xl border border-gray-700" data-id="element-363" data-mp="1w0sx2999y68m">
                <h3 className="font-semibold text-white mb-2" data-id="element-364" data-mp="18aynq1o5yzt4">
                  Marketing Agencies
                </h3>
                <p className="text-sm text-gray-400 mb-4" data-id="element-365" data-mp="13cx4ngqqn0hn">
                  Source fast and manage existing talent agency partners.
                </p>
                <a href="#" className="text-sm font-medium text-white hover:text-gray-300 flex items-center gap-1" data-id="element-366" data-mp="3exe8q8xw6fhq">
                  Learn more <ChevronRight size={16} data-id="element-367" data-mp="360ndfyr5z4o7" />
                </a>
              </div>
              <div className="bg-gray-800/50 backdrop-blur-sm p-6 rounded-xl border border-gray-700" data-id="element-368" data-mp="3a179ez00428r">
                <h3 className="font-semibold text-white mb-2" data-id="element-369" data-mp="1lvwy2ykq9a6">
                  Talent Agencies
                </h3>
                <p className="text-sm text-gray-400 mb-4" data-id="element-370" data-mp="6iw28bnln808">
                  Turn your roster into bookable, always-live public media kits.
                </p>
                <a href="#" className="text-sm font-medium text-white hover:text-gray-300 flex items-center gap-1" data-id="element-371" data-mp="3tnlqemg2ruhd">
                  Learn more <ChevronRight size={16} data-id="element-372" data-mp="2i8ycju0a17vn" />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
};